import { render, staticRenderFns } from "./ToastificationCustom.vue?vue&type=template&id=a053aa50&scoped=true"
import script from "./ToastificationCustom.vue?vue&type=script&lang=js"
export * from "./ToastificationCustom.vue?vue&type=script&lang=js"
import style0 from "./ToastificationCustom.vue?vue&type=style&index=0&id=a053aa50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a053aa50",
  null
  
)

export default component.exports